// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2j75y","colMaxWidth":"Table_colMaxWidth__oMtuQ"};